import { FuelIllustration } from '@frete.com/fuel-react'
import * as Styled from './styled'
import { useNavigate } from 'react-router-dom'
import { usePath } from '~hooks'

function AddNumber() {
  const navigate = useNavigate()
  const path = usePath()

  setTimeout(() => {
    navigate('/numeros-contato', { state: { previousPath: path } })
  }, 3500)

  return (
    <Styled.Container data-testid="add-number-container">
      <FuelIllustration name="high-five" alt="high-five" width={180} height={180} />
      <Styled.Title>Sucesso!</Styled.Title>
      <Styled.Subtitle displayInline>Salvamos suas alterações.</Styled.Subtitle>
    </Styled.Container>
  )
}

export default AddNumber
